// extracted by mini-css-extract-plugin
module.exports = {"sideMenuAvatarRow":"Avatar_sideMenuAvatarRow__1hTIN","sideMenuNameText":"Avatar_sideMenuNameText__2hNoI"};